import React, {useEffect, useState} from 'react';
import '../css/footer.css';

const SocialMedia = ({ socialMedia, title }) => {
    const [icons, setIcons] = useState([]);
    

    useEffect(() => {
        const fetchIcons = async () => {
            if (socialMedia && socialMedia.length > 0) {
                const promises = socialMedia.map(social => {
                    return social.icon && social.icon.data ? social.icon.data.attributes.url : '';
                });
                const iconUrls = await Promise.all(promises);
                setIcons(iconUrls);
            }
        };

        fetchIcons();
    }, [socialMedia]);


    return (
        <div className="socialMedia">
            <span style={{ display: 'block', marginBottom: '10px' }}>{title}</span>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {socialMedia?.map((social, index) => (
                    <a key={index} href={social.url} style={{ margin: '0 10px' }}>
                        {icons[index] ? (
                            <img
                                src={icons[index]}
                                alt={social.icon.data.attributes.alternativeText || 'Social Icon'}
                                style={{ width: '20px', height: '20px' }}
                            />
                        ) : (
                            <span>Visit our page at {social.url}</span>
                        )}
                    </a>
                ))}
            </div>
        </div>
    );


};

export default SocialMedia;
